// LandcoverComponent.js

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const LandcoverComponent = ({
  mapInstance,
  isVisible = false,
  opacity = 100,
  id = 'landcover2020',
  onError
}) => {
  const [tileUrl, setTileUrl] = useState(null);
  const [errorDetails, setErrorDetails] = useState(null);

  useEffect(() => {
    if (!isVisible) {
      setTileUrl(null);
      return;
    }

    async function fetchMapId() {
      try {
        const response = await fetch(`/api/landcover_mapid`);
        if (!response.ok) {
          throw new Error(`Server error: ${response.status} ${response.statusText}`);
        }
        const { mapid, token } = await response.json();
        const url = token
          ? `https://earthengine.googleapis.com/v1/${mapid}/tiles/{z}/{x}/{y}?token=${token}`
          : `https://earthengine.googleapis.com/v1/${mapid}/tiles/{z}/{x}/{y}`;
        setTileUrl(url);
      } catch (err) {
        console.error('Error fetching mapId:', err);
        setErrorDetails('Failed to load land cover layer.');
        if (onError) onError(err);
      }
    }

    fetchMapId();
  }, [isVisible, onError]);

// LandcoverComponent.js (updated section)
useEffect(() => {
  if (!mapInstance || !tileUrl || !isVisible) return;
  // Use the original ID without suffix
  const layerId = id; // Changed from `${id}-landcover`

  try {
    // Remove existing layer/source if they exist
    if (mapInstance.getLayer(layerId)) {
      mapInstance.removeLayer(layerId);
    }
    if (mapInstance.getSource(layerId)) {
      mapInstance.removeSource(layerId);
    }

    // Add new source
    mapInstance.addSource(layerId, {
      type: 'raster',
      tiles: [tileUrl],
      tileSize: 256,
    });

    // Add the new layer
    mapInstance.addLayer({
      id: layerId, // Now matches config ID
      type: 'raster',
      source: layerId,
      paint: {
        'raster-opacity': opacity / 100,
      },
      layout: {
        visibility: isVisible ? 'visible' : 'none',
      },
    });


      // Listen for errors
      const onErrorHandler = (e) => {
        console.error('Tile loading error:', e);
        setErrorDetails('Error loading land cover tiles.');
        if (onError) onError(e);
      };
      mapInstance.on('error', onErrorHandler);

      // Cleanup on unmount or when dependencies change
      return () => {
        mapInstance.off('error', onErrorHandler);
        if (mapInstance.getLayer(layerId)) {
          mapInstance.removeLayer(layerId);
        }
        if (mapInstance.getSource(layerId)) {
          mapInstance.removeSource(layerId);
        }
      };
    } catch (err) {
      console.error('Error adding land cover layer:', err);
      setErrorDetails('Failed to add land cover layer.');
      if (onError) onError(err);
    }
  }, [mapInstance, tileUrl, isVisible, opacity, id, onError]);

  if (errorDetails) {
    return (
      <div
        style={{
          color: 'red',
          padding: '10px',
          background: '#ffeeee',
          margin: '10px',
          borderRadius: '5px'
        }}
      >
        Landcover Layer Error: {errorDetails}
      </div>
    );
  }

  return null;
};

// Prop type validation
LandcoverComponent.propTypes = {
  mapInstance: PropTypes.object.isRequired,
  isVisible: PropTypes.bool,
  opacity: PropTypes.number,
  id: PropTypes.string,
  onError: PropTypes.func
};

export default LandcoverComponent;
